import { OrientacaoRowModel } from '../model-orientacoes'
import { sortOrientacoes } from './sortOrientacoes'

export function mergeSortOrientacoes(
  orientacoesDb: ReadonlyArray<OrientacaoRowModel>,
  orientacoesCache: ReadonlyArray<OrientacaoRowModel>,
  sort: ReadonlyArray<string>
): OrientacaoRowModel[] {
  const orientacoesDatabaseOrdenadas = sortOrientacoes(orientacoesDb, sort)
  return [...orientacoesCache, ...orientacoesDatabaseOrdenadas]
}
